import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { IDialogContent } from '../interfaces/dialog-content.interface';

@Component({
  selector: 'lib-confirm-dialog',
  imports: [TranslatePipe],
  templateUrl: './confirm-dialog.html',
  styleUrl: './confirm-dialog.scss',
})
export class ConfirmDialog {
  public content: IDialogContent = { titleTranslationLabel: '', messageTranslationLabel: '' };

  protected activeModal = inject(NgbActiveModal);
}
